// @ts-nocheck
import React, { useEffect } from 'react';
import { createContext , useState , useContext} from "react";
import PropTypes from 'prop-types';
import { PaletteMode } from '@mui/material';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import {LoginContext,LoadingContext,AuthContext,MsgContext,MsgOpenContext,MsgOpenErrContext} from '../Default';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { styled, alpha } from '@mui/material/styles';
import logo from '../../TIP_yoko.svg';
import Menu, { MenuProps } from '@mui/material/Menu';
import { useIntl  , FormattedMessage } from 'react-intl';
import { Context } from "./IntlProviderWrapper";
import { Link} from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha
} from "react-google-recaptcha-v3";
//import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import ReactGA from "react-ga4";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SessionTimeout from './SessionTimeout';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

ReactGA.initialize(process.env.REACT_APP_GA_KEY);

interface AppAppBarProps {
  mode: PaletteMode;
  toggleColorMode: () => void;
}

      // イベントの設定
window.addEventListener("beforeunload", function (event) {
    //event.preventDefault();
    //event.returnValue = "リロード禁止です！";
  });
  

function AppAppBar({ mode, toggleColorMode }: AppAppBarProps) {
  const intl = useIntl();
  const url = new URL(location.href)
  const [open, setOpen] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [loginErr, setLoginErr] = React.useState(false);
  const {login,setLogin} = useContext(LoginContext);
  const {auth,setAuth} = useContext(AuthContext);
  const {msg,setMsg} = useContext(MsgContext);
  const {msgOpen,setMsgOpen} = useContext(MsgOpenContext);
  const {msgOpenErr,setMsgOpenErr} = useContext(MsgOpenErrContext);
  const {loading,setLoading} = useContext(LoadingContext);
  const [data,setData] = React.useState<Post[]>([]);
  const [searchDispFlag, setSearchDispFlag] = React.useState(true);
  const [columnDispFlag, setColumnDispFlag] = React.useState(true);
  const [columnManageDispFlag, setColumnManageDispFlag] = React.useState(true);
  const [maintenanceNoticeDispFlag, setMaintenanceNoticeDispFlag] = React.useState(true);
  const [maintenanceNewsDispFlag, setMaintenanceNewsDispFlag] = React.useState(true);
  const [maintenanceSeoDispFlag, setMaintenanceSeoDispFlag] = React.useState(true);
  const [maintenanceSitemapDispFlag, setMaintenanceSitemapDispFlag] = React.useState(true);
  const [sitemapDispFlag, setSitemapDispFlag] = React.useState(true);
  const [newsDispFlag, setNewsDispFlag] = React.useState(true);
  const [noticeDispFlag, setNoticeDispFlag] = React.useState(true);
  const [moveCount, setMoveCount] = React.useState(0);
  const [tabValue, setTabValue] = React.useState((url.pathname.toLowerCase()=="/column"||url.pathname.toLowerCase()=="/columndetail") ? 1 : (url.pathname.toLowerCase()=="/news") ? 2:url.pathname.toLowerCase()=="/notification" ? 3:url.pathname.toLowerCase()=="/relatedLinks" ? 4:0 );
  const [tabValueSub, setTabValueSub] = React.useState(0);
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };
  const onUnload = (e:any) => {
     window.location.reload(false);
  }
  
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  
  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '4px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));


  const scrollToSection = (sectionId: string) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
      setOpen(false);
    }
  };

  const [language, setLanguage] = React.useState('');
  const { switchLang } = React.useContext(Context);
  const [id, setId] = React.useState('');
  const [pass, setPass] = React.useState('');

  const handleChange2 = (event:SelectChangeEvent) => {
    setId(event.target.value);
  }
    const handleChange3 = (event:SelectChangeEvent) => {
    setPass(event.target.value);
  }
  
  useEffect(() => {
       const reload = document.getElementById("reload");
       if(language == ''){
         document.documentElement.lang = navigator.language.substring(0,2);
         reload.onclick();
         
       }else{
         document.documentElement.lang = language;
         reload.onclick();
       }
   }, [language]);
   
     useEffect(() => {
       if(window.location.pathname =='/' || window.location.pathname=='/search'||window.location.pathname=='/searchDetail'){
         setSearchDispFlag(false);
         
       }else{
         setSearchDispFlag(true);
       }
       if(window.location.pathname =='/column' ||window.location.pathname=='/columnDetail'){
         setColumnDispFlag(false);
       }else{
         setColumnDispFlag(true);
       }
       if(window.location.pathname =='/columnManage'){
         setColumnManageDispFlag(false);
       }else{
         setColumnManageDispFlag(true);
       }
       if(window.location.pathname =='/maintenanceNotice'){
         setMaintenanceNoticeDispFlag(false);
       }else{
         setMaintenanceNoticeDispFlag(true);
       }
       if(window.location.pathname =='/maintenanceNews'){
         setMaintenanceNewsDispFlag(false);
       }else{
         setMaintenanceNewsDispFlag(true);
       }
        if(window.location.pathname =='/news'){
         setNewsDispFlag(false);
       }else{
         setNewsDispFlag(true);
       }
       if(window.location.pathname =='/notification'){
         setNoticeDispFlag(false);
       }else{
         setNoticeDispFlag(true);
       }
       if(window.location.pathname =='/maintenanceSeo'){
        setMaintenanceSeoDispFlag(false);
       }else{
         setMaintenanceSeoDispFlag(true);
       }
       if(window.location.pathname =='/relatedLinks'){
        setSitemapDispFlag(false);
       }else{
         setSitemapDispFlag(true);
       }
      if(window.location.pathname =='/maintenanceSitemap'){
        setMaintenanceSitemapDispFlag(false);
       }else{
         setMaintenanceSitemapDispFlag(true);
       }
        
   }, [moveCount]);


  
  async function Login(username: string,password: string) {
    try{
    let value = localStorage.getItem("login");
    if(value !== null){
      const session = JSON.parse(value);
      if(session.count > 5){
        var date_difference = Date.now() - session.time;
        if(date_difference < 1000 * 60 * 30){
          setLoginErr(true);
          setOpen4(true);
          return;
        }else{
          const param1 = { // 渡したいパラメータをJSON形式で書く
            count: 0,
            time:Date.now()
          };
          localStorage.setItem("login", JSON.stringify(param1));
        }
      }
    }
    
    const url = process.env.REACT_APP_GET_USER_API_URL;
    //const url = 'https://qiita.com/api/v2/users/wataru86'
  const bodyData = {
    "username":username,
    "password":password
  };
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  setLoading(true);
  return fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok){
        setOpen4(true);
        setLoginErr(false);
        throw new Error('status is not 200');
      }
    return response.json();
    })
    .then(jsondata => {
    if(jsondata.result){
          ReactGA.event({
      category: "Login",
      action: "Login",
      label: id, // Optional
    });
    setOpen(false);
    setOpen3(false);
    setOpen3(true);
    setOpen4(false);
    setLogin(true);
    if(jsondata.manageFlag === '1'){
      setAuth(true);
    }
    setLoginErr(false);
    //setLogin(true);
    setLoading(false);
    setTimeout(() => {
    setOpen3(false);
    }, 5000);
    }else{
      let count = 0 ;
      const value2 = localStorage.getItem("login");
      if(value2 !== null){
        const session2 = JSON.parse(value2);
        count = session2.count;
      }
      const param2 = { // 渡したいパラメータをJSON形式で書く
        count: count+1,
        time:Date.now()
      };
      localStorage.setItem("login", JSON.stringify(param2));
      setOpen4(true);
      setLoading(false);
      setLoginErr(false);
    }
    })
    .catch(error => {
    setOpen4(true);
    setLoading(false);
    setLoginErr(false);
    });
    }catch{
      setOpen4(true);
      setLoading(false);
      setLoginErr(false);
    }
}

  const editingHandler = () => {
    if(id!=""&&pass!=""){
      Login(id,pass);
    }
    return false;
  }

  const stopEditingHandler = () => {
    //setLogin(false);
    setLogin(false);
    setAuth(false);
  }
  
  const handleChange = (event:SelectChangeEvent) => {
    setLanguage(event.target.value);
    switchLang(event.target.value);
  }
  const handleClickOpen = () => {
    setId('');
    setPass('');
    setOpen(true);
    setOpen4(false);
  };

  const handleClose = () => {
    setOpen(false);
    setOpen4(false);
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
    const addButtonClick = () => {
    // document.getElementById("demo-form").submit();
    setTabValue(0);
    const home = document.getElementById("home");
    home?.click();
    setMoveCount(moveCount+1)
  };
    const columnButtonClick = () => {
      setTabValue(1);
    // document.getElementById("demo-form").submit();
    const column = document.getElementById("column");
    column?.click();
    setMoveCount(moveCount+1);
  };
      const sitemapButtonClick = () => {
      setTabValue(4);
    // document.getElementById("demo-form").submit();
    const sitemap = document.getElementById("sitemap");
    sitemap?.click();
    setMoveCount(moveCount+1);
    
  };
  const howToUseButtonClick = () => {
    // document.getElementById("demo-form").submit();
    const howToUse = document.getElementById("howToUse");
    setTabValue((url.pathname.toLowerCase()=="/column"||url.pathname.toLowerCase()=="/columndetail") ? 1 : (url.pathname.toLowerCase()=="/news") ? 2:url.pathname.toLowerCase()=="/notification" ? 3:url.pathname.toLowerCase()=="/sitemap" ? 4:0);
    howToUse?.click();
    
  };
      const columnManageButtonClick = () => {
    // document.getElementById("demo-form").submit();
    setTabValue(6);
    setTabValueSub(1);
    const columnManage = document.getElementById("columnManage");
    columnManage?.click();
    setMoveCount(moveCount+1);
  };
  const maintenanceNewsButtonClick = () => {
    // document.getElementById("demo-form").submit();
    setTabValue(6);
    setTabValueSub(3);
    const maintenanceNews = document.getElementById("maintenanceNews");
    maintenanceNews?.click();
    setMoveCount(moveCount+1);
  };
  const newsButtonClick = () => {
    // document.getElementById("demo-form").submit();
    setTabValue(2);
    const news = document.getElementById("news");
    news?.click();
    setMoveCount(moveCount+1);
  };
  const noticeButtonClick = () => {
    // document.getElementById("demo-form").submit();
    setTabValue(3);
    const notice = document.getElementById("notice");
    notice?.click();
    setMoveCount(moveCount+1);
  };
  const maintenanceNoticeButtonClick = () => {
    setTabValue(6);
    setTabValueSub(2);
    // document.getElementById("demo-form").submit();
    const maintenanceNotice = document.getElementById("maintenanceNotice");
    maintenanceNotice?.click();
    setMoveCount(moveCount+1);
  };
    const maintenanceSeoButtonClick = () => {
    setTabValue(6);
    setTabValueSub(4);
    // document.getElementById("demo-form").submit();
    const maintenanceSeo = document.getElementById("maintenanceSeo");
    maintenanceSeo?.click();
    setMoveCount(moveCount+1);
  };
    const maintenanceSitemapButtonClick = () => {
    setTabValue(6);
    setTabValueSub(5);
    // document.getElementById("demo-form").submit();
    const maintenanceSitemap = document.getElementById("maintenanceSitemap");
    maintenanceSitemap?.click();
    setMoveCount(moveCount+1);
  };

  const open2 = Boolean(anchorEl);
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  let button;
  const handleClick = () => {
    setIsAuthenticated(!isAuthenticated);
  }
  return (
    <AppBar
      position="fixed"
      sx={{ boxShadow: 0, bgcolor: 'transparent', backgroundImage: 'none', mt: 2 }}
    >
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SessionTimeout isAuthenticated={login} logOut={stopEditingHandler} />
       <Collapse in={open3}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen3(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          <FormattedMessage id = "langID00040"/>
        </Alert>
      </Collapse>
      <Collapse in={msgOpen} timeout="auto"　>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setMsgOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          <FormattedMessage id = {msg}/>
        </Alert>
      </Collapse>
      <Collapse in={msgOpenErr} timeout="auto">
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setMsgOpenErr(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          <FormattedMessage id = {msg}/>
        </Alert>
      </Collapse>
      <Container maxWidth="xl">

        <Toolbar
          variant="regular"
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
            borderRadius: '999px',
            backdropFilter: 'blur(24px)',
            maxHeight: 40,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'hsla(220, 60%, 99%, 0.6)',
            boxShadow:
              '0 1px 2px hsla(210, 0%, 0%, 0.05), 0 2px 12px hsla(210, 100%, 80%, 0.5)',
            ...theme.applyStyles('dark', {
              bgcolor: 'hsla(220, 0%, 0%, 0.7)',
              boxShadow:
                '0 1px 2px hsla(210, 0%, 0%, 0.5), 0 2px 12px hsla(210, 100%, 25%, 0.3)',
            }),
          })}
        >
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
          <img src={logo} className="App-logo" alt="logo"  width={"200px"} onClick={() => addButtonClick()} />

            <Box sx={{ display: { xs: 'none', md: 'flex' }, px: 5  }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="icon position tabs example"
    >
      <Tab icon={tabValue==0  ? <KeyboardArrowDownIcon /> :<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => addButtonClick()} disabled={searchDispFlag==false} label={<span style={{ fontSize: '20px', fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00001" })}</span>} />
      <Tab icon={tabValue==1  ? <KeyboardArrowDownIcon /> :<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => columnButtonClick()} disabled={columnDispFlag==false}  label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00070" })}</span>} />
      <Tab icon={tabValue==2  ? <KeyboardArrowDownIcon /> :<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => newsButtonClick()} disabled={newsDispFlag==false}  label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00077" })}</span>} />
      <Tab icon={tabValue==3  ? <KeyboardArrowDownIcon /> :<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => noticeButtonClick()} disabled={noticeDispFlag==false}  label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00080" })}</span>} />
      <Tab icon={tabValue==5  ? <KeyboardArrowDownIcon /> :<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => sitemapButtonClick()} disabled={sitemapDispFlag==false}  label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00084" })}</span>} />
      <Tab icon={<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start"  onClick={(e) => {
        howToUseButtonClick()
         e.preventDefault()
         }} label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00085" })}</span>} />
      <Tab icon={tabValue==4  ?<KeyboardArrowDownIcon />:<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => noticeButtonClick()} hidden={auth==false}　onMouseOver={handleMenu}  label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00093" })}</span>} />

      <Menu
              id="menu-app-bar"
              anchorEl={anchorElMenu}
              open={Boolean(anchorElMenu)}
              onClose={handleCloseMenu}
              MenuListProps={{ onMouseLeave: handleCloseMenu }}
            >
              <MenuItem sx={{ height: '60px' }}>
                <Tab icon={tabValueSub==1  ?<KeyboardArrowDownIcon />:<KeyboardArrowRightIcon />} sx={{ paddingLeft:"2px", display: {fontsize:"20px"}, height: '10px'}} iconPosition="start" onClick={() => columnManageButtonClick()} disabled={columnManageDispFlag==false} hidden={auth==false}label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00071" })}</span>} />

              </MenuItem>
              <MenuItem sx={{ height: '60px' }}>
                    <Tab icon={tabValueSub==2  ?<KeyboardArrowDownIcon />:<KeyboardArrowRightIcon />}  sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => maintenanceNoticeButtonClick()} disabled={maintenanceNoticeDispFlag==false} hidden={auth==false}label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00076" })}</span>} />
              </MenuItem>

              <MenuItem sx={{ height: '60px' }}>
                <Tab icon={tabValueSub==3  ?<KeyboardArrowDownIcon />:<KeyboardArrowRightIcon />}  sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => maintenanceNewsButtonClick()} disabled={maintenanceNewsDispFlag==false} hidden={auth==false}label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00081" })}</span>} />
              </MenuItem>
              <MenuItem sx={{ height: '60px' }}>
                    <Tab icon={tabValueSub==4  ?<KeyboardArrowDownIcon />:<KeyboardArrowRightIcon />}  sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => maintenanceSeoButtonClick()} disabled={maintenanceSeoDispFlag==false} hidden={auth==false}label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00082" })}</span>} />
              </MenuItem>
               <MenuItem sx={{ height: '60px' }}>
                    <Tab icon={tabValueSub==5  ?<KeyboardArrowDownIcon />:<KeyboardArrowRightIcon />}  sx={{ paddingLeft:"2px", display: {fontsize:"20px"}}} iconPosition="start" onClick={() => maintenanceSitemapButtonClick()} disabled={maintenanceSitemapDispFlag==false} hidden={auth==false}label={<span style={{ fontSize: '20px' , fontWeight:"bold" }}>{intl.formatMessage({ id: "langID00083" })}</span>} />
              </MenuItem>

            </Menu>
     

      </Tabs>
              <Button
                id="loading"
                variant="text"
                color="info"
                size="small"
                onClick={() => setLoading(true)}
                disabled
                sx={{ display: "none"  }}
              >
              </Button>
              <Button
                id="loaded"
                variant="text"
                color="info"
                size="small"
                onClick={() => setLoading(false)}
                disabled
                sx={{ display: "none"  }}
              >
              </Button>
               <Link hidden id="home" to="/">テキスト</Link>
               <Link hidden id="column" to="/column">テキスト</Link>
               <Link hidden id="columnManage" to="/columnManage">テキスト</Link>
               <Link hidden id="maintenanceNotice" to="/maintenanceNotice">テキスト</Link>
               <Link hidden id="maintenanceSeo" to="/maintenanceSeo">テキスト</Link>
               <Link hidden id="howToUse" to="/ALSIThreatIntelligenceLabご利用ガイド.pdf" target="_blank">テキスト</Link>
               <Link hidden id="maintenanceSitemap" to="/maintenanceSitemap">テキスト</Link>
               <Link hidden id="sitemap" to="/relatedLinks">テキスト</Link>
               <Link hidden id="news" to="/news">テキスト</Link>
               <Link hidden id="notice" to="/notification">テキスト</Link>
               <Link hidden id="maintenanceNews" to="/maintenanceNews">テキスト</Link>

            </Box>
          </Box>
           <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              alignItems: 'center',
            }}
          >
          <FormControl  sx={{ display: { xs: 'none', md: 'flex' ,minWidth: 90, fontsize: "10px",cololr:"hsla(220, 25%, 80%, 0.3)" }}}  >
            <InputLabel id="select-locale-label"></InputLabel>
            <Select
              labelId="select-locale-label-label"
              id="select-locale"
              onChange={handleChange}
              defaultValue={navigator.language.substring(0,2)}
              style={{ border:"none", borderColor: 'transparent' ,backgroundColor: "transparent" ,boxShadow:"none"}}
              input={<OutlinedInput label="Tag" />}
              
            >
              <MenuItem value={"ja"}>
              <FormattedMessage id = "langID00002"/>
              </MenuItem>
              <MenuItem value={"en"} > <FormattedMessage id = "langID00003"/></MenuItem>
            </Select>
          </FormControl >
           
             {/* <ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} />  */}
            {!login && <Button id="login" color="primary" variant="text" size="small" onClick={handleClickOpen}>
            <LoginIcon/>&ensp;<FormattedMessage id = "langID00004"/>
            </Button>
            }
            {login && <Button id="logout" color="primary" variant="text" size="small" onClick={stopEditingHandler}>
            <LogoutIcon/>&ensp;<FormattedMessage id = "langID00036"/>
            </Button>
            }
        <Dialog
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            //event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
          },
        }}
      >
        
        <DialogTitle>
        <Grid container><FormattedMessage id = "langID00004"/>
        <Typography 
        aria-owns={open2 ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        ><HelpOutlineIcon  color="primary" fontSize="small"/></Typography></Grid>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open2}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}><FormattedMessage id = "langID00037"/></Typography>
      </Popover>
        </DialogTitle>
        <DialogContent>
        <Collapse in={open4}>
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen4(false);
                setLoginErr(false);
              }}
            >
            <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {!loginErr && <FormattedMessage id = "langID00038"/>}
          {loginErr && <FormattedMessage id = "langID00060"/>}
        </Alert>
      </Collapse>
          <TextField
            autoFocus
            required
            margin="dense"
            id="id"
            name="id"
            label={<FormattedMessage id = "langID00034"/>}
            fullWidth
            variant="standard"
            onChange={handleChange2}
          />

          <TextField
            autoFocus
            required
            margin="dense"
            id="password"
            name="password"
            label={<FormattedMessage id = "langID00035"/>}
            type="password"
            fullWidth
            variant="standard"
            onChange={handleChange3}
            autoComplete="off"
            
          />
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button> */}
          <Button onClick={editingHandler}><FormattedMessage id = "langID00004"/></Button>
        </DialogActions>
      </Dialog>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

AppAppBar.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']).isRequired,
  toggleColorMode: PropTypes.func.isRequired,
};

export default AppAppBar;
